import type { TStatusTone } from "./interfaces"

/**
 * Canonical phase → tone map. The same mapping powers home (`MeetingList`)
 * and detail (`MeetingSummary`); keeping it in one helper means the same
 * meeting reads as the same colour everywhere.
 *
 * Semantics:
 *   - in_progress / transcribed / parsed → info (intermediate states)
 *   - summarized                          → success (the journey is complete)
 *   - ended / detected / fetched          → muted (captured, no analysis yet)
 *   - error                               → danger
 */
const PHASE_TONE: Record<string, TStatusTone> = {
  in_progress: "info",
  transcribed: "info",
  parsed: "info",
  summarized: "success",
  ended: "muted",
  detected: "muted",
  fetched: "muted",
  recovering: "warning",
  error: "danger",
}

export function toneForPhase(phase: string): TStatusTone {
  return PHASE_TONE[phase] ?? "muted"
}
